export default __webpack_public_path__ + "locales/el-GR/Payments.json?hash=802bf804b507533221b34cc57fde7ab3";